import * as React from "react";
function GoogleColoredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1027_1528)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M23.766 12.276c0-.815-.066-1.635-.207-2.438H12.24v4.621h6.482a5.555 5.555 0 01-2.399 3.647v2.998h3.867c2.271-2.09 3.576-5.177 3.576-8.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.24 24c3.237 0 5.966-1.062 7.955-2.896l-3.867-2.998c-1.076.731-2.465 1.146-4.083 1.146-3.131 0-5.786-2.112-6.738-4.952h-3.99v3.091a12.002 12.002 0 0010.723 6.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M5.503 14.3a7.188 7.188 0 010-4.594V6.615H1.517a12.01 12.01 0 000 10.776l3.986-3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.24 4.75a6.52 6.52 0 014.603 1.799l3.427-3.426A11.533 11.533 0 0012.24 0 11.998 11.998 0 001.517 6.615l3.986 3.09C6.45 6.863 9.109 4.75 12.24 4.75z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1027_1528"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
}
const ForwardRef = React.forwardRef(GoogleColoredIcon);
export default ForwardRef;